/* tslint:disable */
/* eslint-disable */




export const ISystemStep = {
    SKIP: 'SKIP',
    ZINC_PLATING: 'ZINC_PLATING',
    SURFACE_PREPARATION: 'SURFACE_PREPARATION',
    PRIMER_PAINTING: 'PRIMER_PAINTING',
    FIRE_PROTECTION_PAINTING: 'FIRE_PROTECTION_PAINTING',
    INTER_LAYER_PAINTING: 'INTER_LAYER_PAINTING',
    TOP_COAT_PAINTING: 'TOP_COAT_PAINTING',
    THICKNESS_MEASUREMENT: 'THICKNESS_MEASUREMENT',
    INCOMING: 'INCOMING',
    SHIPMENT: 'SHIPMENT',
    SITE_PAINTING: 'SITE_PAINTING'
} as const;

export type ISystemStep = typeof ISystemStep[keyof typeof ISystemStep];



